<template>
    <div>
        <div class="font-size-h6 mb-2">
            {{ __('auth.select_phone') }}
        </div>
        <RadioGroup :options="options" v-model="selectedHintIndex"/>
        <div class="mt-6">
            <button class="btn btn-primary"
                    :disabled="selectedHintIndex === null"
                    @click="submit"
            >
                <i class="fas fa-paper-plane"/>
                {{ __('actions.send_thing', {thing: __('auth.mfa_code')}) }}
            </button>
        </div>
    </div>
</template>

<script>
import RadioGroup from "@components/Inputs/RadioGroup.vue";

export default {
    components: {RadioGroup},

    props: {
        hints: Array
    },

    data() {
        return {
            selectedHintIndex: null
        }
    },

    methods: {
        submit() {
            if (this.selectedHintIndex === null) {
                console.error('[MFA] No phone number selected.');
                return;
            }

            this.$emit('select', this.hints[this.selectedHintIndex]);
        }
    },

    computed: {
        options() {
            let entries = {};
            let hintIndex = 0;

            for (let hint of this.hints) {
                entries[hint.phoneNumber] = hintIndex++;
            }

            return entries;
        }
    }
}
</script>
